import { addMilliseconds, formatDistanceStrict } from 'date-fns';
export const humanizeDuration = (duration, unit = null) => {
    let durationInMs = duration;
    if (unit === 'seconds' || unit === 's') {
        durationInMs = duration * 1000;
    }
    else if (unit === 'minutes' || unit === 'm') {
        durationInMs = duration * 60 * 1000;
    }
    else if (unit === 'hours' || unit === 'h') {
        durationInMs = duration * 60 * 60 * 1000;
    }
    else if (unit === 'days' || unit === 'd') {
        durationInMs = duration * 24 * 60 * 60 * 1000;
    }
    else if (unit === 'weeks' || unit === 'w') {
        durationInMs = duration * 7 * 24 * 60 * 60 * 1000;
    }
    else if (unit === 'months' || unit === 'M') {
        durationInMs = duration * 30 * 24 * 60 * 60 * 1000;
    }
    else if (unit === 'years' || unit === 'y') {
        durationInMs = duration * 365 * 24 * 60 * 60 * 1000;
    }
    // Handle durations under a minute
    if (durationInMs < 60 * 1000) {
        const seconds = Math.floor(durationInMs / 1000);
        return `${seconds} seconds`;
    }
    const now = new Date();
    const futureDate = addMilliseconds(now, durationInMs);
    const result = formatDistanceStrict(now, futureDate, { addSuffix: false });
    const cleanedResult = result.replace('about ', '');
    return cleanedResult;
};
